import { render, staticRenderFns } from "./userProfileEntityDocumentsData.vue?vue&type=template&id=2b63d4ea&scoped=true"
import script from "./userProfileEntityDocumentsData.vue?vue&type=script&lang=js"
export * from "./userProfileEntityDocumentsData.vue?vue&type=script&lang=js"
import style0 from "./userProfileEntityDocumentsData.vue?vue&type=style&index=0&id=2b63d4ea&prod&lang=scss&scoped=true"
import style1 from "./userProfileEntityDocumentsData.vue?vue&type=style&index=1&id=2b63d4ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63d4ea",
  null
  
)

export default component.exports